import React from 'react';
import { get } from 'lodash';
import PropTypes from 'prop-types';
import moment from 'moment';
import StatusIcon from 'modules/common/components/StatusIcon';

function TransactionInformation({ data }) {
  const spanGap = 8;

  return (
    <>
      <div className="p-3" style={{ maxHeight: '700px', overflowY: 'scroll' }}>
        <table className="transaction-table table table-borderless table-striped table-sm">
          <tbody>
            <tr>
              <td className="text-dark font-weight-bold" colSpan={spanGap}>
                Payment Status
              </td>
              <td colSpan={4}>
                <StatusIcon
                  value={get(data, 'attributes.transaction_status')}
                />
              </td>
            </tr>
            <tr>
              <td className="text-dark font-weight-bold" colSpan={spanGap}>
                SOA Number / Order Payment No. / OVR No.
              </td>
              <td colSpan={4}>
                <b>
                  {get(data, 'included.module.attributes.soa_number') || '-'}
                </b>
              </td>
            </tr>
            <tr>
              <td className="text-dark font-weight-bold" colSpan={spanGap}>
                Reference No. Generated At
              </td>
              <td colSpan={4}>
                <b>
                  {moment(get(data, 'attributes.pgi_url_generated_at')).format(
                    'YYYY-MM-DD HH:mm'
                  ) || '-'}
                </b>
              </td>
            </tr>
            <tr>
              <td className="text-dark font-weight-bold" colSpan={spanGap}>
                Payment Amount
              </td>
              <td colSpan={4}>
                <b>
                  {get(data, 'attributes.amount')
                    ? `PHP ${get(data, 'attributes.amount')}`
                    : '-'}
                </b>
              </td>
            </tr>
            <tr>
              <td className="text-dark font-weight-bold" colSpan={spanGap}>
                Resident of Las Piñas
              </td>
              <td colSpan={4}>
                <b>
                  {get(data, 'included.taxPayer.attributes.is_resident')
                    ? 'Yes'
                    : 'No'}
                </b>
              </td>
            </tr>
            <tr>
              <td className="text-dark font-weight-bold" colSpan={spanGap}>
                Permit Type
              </td>
              <td colSpan={4}>
                <b>Miscellaneous Fees</b>
              </td>
            </tr>
            <tr>
              <td className="text-dark font-weight-bold" colSpan={spanGap}>
                Transaction ID
              </td>
              <td colSpan={4}>
                <b>{get(data, 'attributes.txnid')}</b>
              </td>
            </tr>
            <tr>
              <td className="text-dark font-weight-bold" colSpan={spanGap}>
                Reference Number
              </td>
              <td colSpan={4}>
                <b>{get(data, 'attributes.refno')}</b>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </>
  );
}

TransactionInformation.propTypes = {
  data: PropTypes.instanceOf(Object).isRequired,
};

export default TransactionInformation;
